import { PrintArea } from '@/types';

export const getViewId = (printArea: PrintArea) => printArea.defaultView.id;
